<template lang="html">

  <div id="back">

    <span class="button-label">BACK</span>

    <div class="button"  v-pop-in="800"
         @touchstart="onTouchStart($event)"
         @touchend="onTouchEnd($event)"
         @click="onTouchEnd($event)">

      <img src="/static/media/icons/arrow.png" />

    </div>

  </div>

</template>

<script lang="js" type="text/javascript">

  import {TweenMax, Quad, Bounce} from "gsap";

  export default  {

    name: 'back',

    props: ['backTo'],

    methods: {

      onTouchEnd(e){


        //if there is a specific link we want to back to, use is. Otherwise go back in the history
        if(this.backTo){

          this.$router.push(this.backTo).catch(err => {
            if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation to current location')) {
                console.log(err);
            }
          });

        }else{

          this.$router.go(-1);

        }

        TweenMax.to( e.target, 0.6, {scale:1, opacity: 1, ease: Quad.easeOut });

      },


      onTouchStart(e){

        TweenMax.to( e.target, 0.6, {scale:0.5, opacity: 1, ease: Quad.easeOut });

      }

    }

  }
</script>

<style scoped lang="scss">
#back {
  position: absolute;
  top: 56px;
  left: 56px;
  z-index: 9999;

  .button-label {
    position: absolute;
    top: 50%;
    right: -15px;
    transform: translate(100%, -50%);

    float: left;
    color: #fff;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 1px;
    font-family: "sofiapro-bold";

    opacity: 0;

    animation: fadeIn 0.5s ease-in forwards;
    animation-delay: 1s;
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 46px;
    height: 45px;

    border-radius: 50%;
    background: #fff;
    box-shadow: 0 10px 10px -4px rgba(0, 51, 141, 0.2);

    img {
      width: 15px;
      height: 15px;
      transform: rotate(-180deg);
    }

    transform: scale(0.5);

    &:hover {
      box-shadow: 0 3px 3px 0 rgba(0, 51, 141, 0.4);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/back.vue